export default {
    isPending: 'isPending',
    isResolved: 'isResolved',
    isRejected: 'isRejected',
};
